import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import './styles/index.css'
import { applyFeizhouDesktopShell } from './utils/desktop-shell.js'
import { initTheme } from './utils/theme.js'

applyFeizhouDesktopShell()
initTheme()

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(Antd)
app.use(Vant)

// Token / 用户 / 空间统一由 initAuth（@/utils/urlAuth → feizhou-bridge）获取，不再从 URL 注入
app.mount('#app')
